module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_A.5a55ec53.mp3";